// src/pages/DetalleMoto.jsx
import { useEffect, useMemo, useRef, useState, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { auth, db } from "../firebase/firebase"; // <- ajusta si tu path es distinto
import { doc, getDoc, updateDoc } from "firebase/firestore";

import { useMoto } from "../hooks/useMoto";
import { useSucursales } from "../hooks/useSucursales";

import {
  uploadFotoJpg,
  clearFoto,
  uploadVideoAny,
  clearVideo,
} from "../services/storage";
import { updateMoto } from "../services/motos";
import {
  webhookPublishAll,
  webhookUpdateWcMl,
  webhookInactivateWcMl,
} from "../services/webhooks";

import {
  normalizeMotoPayload,
  detectTextoClaveCambio,
  fotosArrayFromMoto,
} from "../utils/validation";
import { ESTATUS } from "../constants/status";

// Placeholders
import ph1 from "../assets/Foto_01.png";
import ph2 from "../assets/Foto_02.png";
import ph3 from "../assets/Foto_03.png";
import ph4 from "../assets/Foto_04.png";
import ph5 from "../assets/Foto_05.png";
import ph6 from "../assets/Foto_06.png";
import ph7 from "../assets/Foto_07.png";
import phVideo from "../assets/Video_01.png";

// Iconos
import { SiWoocommerce } from "react-icons/si";
import { FaInstagram, FaFacebook, FaYoutube } from "react-icons/fa";
import mercadolibreIco from "../icons/mercadolibre.svg";

const FOTO_PLACEHOLDERS = [ph1, ph2, ph3, ph4, ph5, ph6, ph7];


console.log("Usuario autenticado:", auth.currentUser?.uid);

export default function DetalleMoto() {
  const { id } = useParams();
  const nav = useNavigate();

  const { moto, setMoto, loading } = useMoto(id);
  const sucursales = useSucursales();

  // Normaliza el hook de sucursales:
  // acepta ["cdmx", "queretaro"] o [{id:"cdmx", nombre:"CDMX"}, ...]
  const sucList = useMemo(() => {
    const arr = Array.isArray(sucursales) ? sucursales : [];
    return arr
      .map((s) =>
        typeof s === "string"
          ? { id: s, nombre: s }
          : {
              id: s.id || s.sucursalId || s.nombre || "",
              nombre: s.nombre || s.label || s.id || "",
            }
      )
      .filter((x) => x.id);
  }, [sucursales]);

  const mapaSucursales = useMemo(
    () => Object.fromEntries(sucList.map((s) => [s.id, s.nombre])),
    [sucList]
  );

  // Perfil/rol
  const [me, setMe] = useState(null);
  const isAdmin = me?.rol === "admin";

  useEffect(() => {
    (async () => {
      const u = auth.currentUser;
      if (!u) return;
      const s = await getDoc(doc(db, "users", u.uid));
      setMe(s.exists() ? { uid: u.uid, email: u.email, ...s.data() } : null);
      const userData = { uid: u.uid, email: u.email, ...s.data() };
  setMe(userData);
  console.log("✅ Usuario logueado:", userData.uid);
  console.log("🎭 Rol:", userData.rol);
  console.log("🏬 sucursalId:", userData.sucursalId);
  console.log("📍 sucursal (legacy):", userData.sucursal);
    })();
  }, []);

  const [form, setForm] = useState({
    nombre: "",
    codigoMoto: "",
    marca: "",
    modelo: "",
    ano: "",
    color: "",
    kilometros: "",
    cilindrada: "",
    valor: "",
    valorRebajado: "",
    financiamiento: "No",
    origen: "Nacional",
    tipoMoto: "",
    categoria: "Seminueva",
    sucursalId: "",
    sucursalNombre: "",
    descripcion: "",
    estatus: ESTATUS.PENDING,
    etiqueta: "",
    fuente: "",
    link_facebookPage: "",
    link_instagram: "",
    link_mercadoLibre: "",
    link_wooCommerce: "",
    link_youtube: "",
    // Admin-only: reset publishedOnce
    _resetPublishedOnce: false,
  });

  const [main, setMain] = useState("");
  const [saving, setSaving] = useState(false);

  const fotoInputsRef = useRef(Array.from({ length: 7 }, () => null));
  const videoInputRef = useRef(null);

  // Inicializa form desde moto
  useEffect(() => {
    if (!moto) return;
    setForm((prev) => ({
      ...prev,
      nombre: moto.nombre || "",
      codigoMoto: moto.codigoMoto || id || "",
      marca: moto.marca || "",
      modelo: moto.modelo || "",
      ano: moto.ano ?? moto.año ?? "",
      color: moto.color || "",
      kilometros: moto.kilometros ?? "",
      cilindrada: moto.cilindrada ?? "",
      valor: (moto.valor ?? "") === 0 ? "" : moto.valor ?? "",
      valorRebajado:
        (moto.valorRebajado ?? 0) === 0 ? "" : moto.valorRebajado ?? 0,
      financiamiento: moto.financiamiento === "Sí" ? "Sí" : "No",
      origen: moto.origen || "Nacional",
      tipoMoto: moto.tipoMoto || "",
      categoria: moto.categoria || "Seminueva",
      sucursalId: moto.sucursalId || moto.sucursal || "",
      sucursalNombre: moto.sucursalNombre || "",
      descripcion: moto.descripcion || "",
      estatus: moto.estatus || ESTATUS.PENDING,
      etiqueta: moto.etiqueta || "",
      fuente: moto.fuente || "",
      link_facebookPage: moto.link_facebookPage || "",
      link_instagram: moto.link_instagram || "",
      link_mercadoLibre: moto.link_mercadoLibre || "",
      link_wooCommerce: moto.link_wooCommerce || "",
      link_youtube: moto.link_youtube || "",
      _resetPublishedOnce: false,
    }));

    const principal =
      moto.foto1 ||
      moto.foto2 ||
      moto.foto3 ||
      moto.foto4 ||
      moto.foto5 ||
      moto.foto6 ||
      moto.foto7 ||
      "";
    setMain(principal);
  }, [moto, id]);

  // Vista de fotos con placeholders
  const fotos = useMemo(() => {
    if (!moto) return [];
    const reales = [
      moto.foto1 || null,
      moto.foto2 || null,
      moto.foto3 || null,
      moto.foto4 || null,
      moto.foto5 || null,
      moto.foto6 || null,
      moto.foto7 || null,
    ];
    return reales.map((url, i) => url || FOTO_PLACEHOLDERS[i]);
  }, [moto]);

  const hasAllPhotos = useMemo(
    () => !!moto && [1, 2, 3, 4, 5, 6, 7].every((n) => !!moto[`foto${n}`]),
    [moto]
  );
  const hasVideo = useMemo(() => !!moto?.video, [moto]);
  const hasAllMedia = hasAllPhotos && hasVideo;

  // Flags de control (regla 1/2/3)
  const publishedOnce = useMemo(() => {
    return Boolean(
      moto?.publishedOnce ||
        moto?.publishedAt_wc ||
        moto?.publishedAt_ml ||
        moto?.link_wooCommerce ||
        moto?.link_mercadoLibre
    );
  }, [moto]);

  const isInactive = moto?.estatus === ESTATUS.INACTIVA;
  const lockUI = isInactive && !isAdmin; // bloquea edición a no-admin

  // Handlers de form
  const onChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      setForm((v) => ({ ...v, [name]: !!checked }));
    } else {
      setForm((v) => ({ ...v, [name]: value }));
    }
  };

  // Subidas/Quitados (bloquea si INACTIVA y no admin)
  const handleUploadFoto = useCallback(
    async (index, file) => {
      if (lockUI) return alert("La moto está inactiva. Solo Admin puede editar.");
      try {
        const { field, url } = await uploadFotoJpg(id, index, file);
        setMoto((prev) => {
          const next = { ...prev, [field]: url };
          if (!main || FOTO_PLACEHOLDERS.includes(main)) setMain(url);
          return next;
        });
      } catch (err) {
        console.error(err);
        alert("No se pudo subir la foto.");
      }
    },
    [id, setMoto, main, lockUI]
  );

  const handleRemoveFoto = useCallback(
    async (index) => {
      if (lockUI) return alert("La moto está inactiva. Solo Admin puede editar.");
      try {
        const field = await clearFoto(id, index);
        setMoto((prev) => {
          const wasMain = main === (prev?.[field] || "");
          const next = { ...prev, [field]: null };
          if (wasMain) {
            const nextMain =
              [1, 2, 3, 4, 5, 6, 7]
                .map((n) => next?.[`foto${n}`] || "")
                .find(Boolean) || "";
            setMain(nextMain);
          }
          return next;
        });
      } catch (err) {
        console.error(err);
        alert("No se pudo quitar la foto.");
      }
    },
    [id, setMoto, main, lockUI]
  );

  const handleUploadVideo = useCallback(
    async (file) => {
      if (lockUI) return alert("La moto está inactiva. Solo Admin puede editar.");
      try {
        const url = await uploadVideoAny(id, file);
        setMoto((prev) => ({ ...prev, video: url }));
      } catch (err) {
        console.error(err);
        alert("No se pudo subir el video.");
      }
    },
    [id, setMoto, lockUI]
  );

  const handleRemoveVideo = useCallback(async () => {
    if (lockUI) return alert("La moto está inactiva. Solo Admin puede editar.");
    try {
      await clearVideo(id);
      setMoto((prev) => ({ ...prev, video: null }));
    } catch (err) {
      console.error(err);
      alert("No se pudo quitar el video.");
    }
  }, [id, setMoto, lockUI]);

  // Guardar + Webhooks + Reglas
  const guardar = useCallback(async () => {
    if (!moto) return;
    setSaving(true);
    try {
      // UI guardas básicas
      if (form.estatus === ESTATUS.PUBLICADA && !hasAllMedia) {
        alert("Para publicar debes tener 7 fotos y 1 video subidos.");
        setSaving(false);
        return;
      }

      // Regla 2: Si está INACTIVA, solo Admin puede tocar
      if (isInactive && !isAdmin) {
        alert("La moto está inactiva. Solo Admin puede modificar o reactivar.");
        setSaving(false);
        return;
      }

      const wasInactive = moto.estatus === ESTATUS.INACTIVA;

      // Regla 1: Si YA se publicó antes (publishedOnce) y no eres Admin, NO puedes publicar otra vez
      const wantsPublish = form.estatus === ESTATUS.PUBLICADA;
        if (wasInactive && wantsPublish && publishedOnce && !isAdmin) {
        alert("Esta moto ya fue publicada. Solo Admin puede permitir una republicación.");
        setSaving(false);
      return;
      }

      // Normaliza
      const payload = normalizeMotoPayload(form, id, moto.fuente || "");

      // Forzar sucursalId / sucursalNombre
      payload.sucursalId = form.sucursalId || moto.sucursalId || "";
      payload.sucursalNombre =
        form.sucursalNombre ||
        mapaSucursales[payload.sucursalId] ||
        moto.sucursalNombre ||
        moto.sucursal || // legacy
        "";

      // Si va a PUBLICADA, exigir sucursalId
      const willBePublished = payload.estatus === ESTATUS.PUBLICADA;
      if (willBePublished && !payload.sucursalId) {
        alert("Debes seleccionar una sucursal (ID) antes de publicar.");
        setSaving(false);
        return;
      }

      // valorRebajado → null si vacío o 0
      payload.valorRebajado =
        !form.valorRebajado || Number(form.valorRebajado) === 0
          ? null
          : Number(form.valorRebajado);

      const wasPublished = moto.estatus === ESTATUS.PUBLICADA;
      const willBeInactivated = payload.estatus === ESTATUS.INACTIVA;

      // Admin puede “resetear” publishedOnce para permitir republicación
      if (isAdmin && form._resetPublishedOnce) {
        payload.publishedOnce = false;
      }

      // Si es la PRIMERA publicación, marca publishedOnce
      if (!publishedOnce && willBePublished) {
        payload.publishedOnce = true;
      }

      const textoClaveCambio = detectTextoClaveCambio(moto, payload);


      // Persistir en Firestore
      await updateMoto(id, payload);

      // Mezcla local para webhooks
      const current = { ...moto, ...payload };

      const valorRebajadoForWebhook =
        current.valorRebajado == null || Number(current.valorRebajado) === 0
          ? ""
          : Number(current.valorRebajado);

      const etiquetaQuitada =
        (moto.etiqueta || "") !== "" && (payload.etiqueta || "") === "";

      const fotosArr = fotosArrayFromMoto(current);
      const videoUrl = current.video || "";
      const linkWoo = current.link_wooCommerce || "";
      const linkML = current.link_mercadoLibre || "";

      // 1) Publicar (de NO publicada -> publicada)
      if (!wasPublished && willBePublished && hasAllMedia) {
        await webhookPublishAll(id, current, fotosArr, videoUrl);
        await updateDoc(doc(db, "motos", id), {
          publishedAt_wc: new Date().toISOString(),
          publishedOnce: true,
        }).catch(() => {});
      }
      // 2) Inactivar → solo si ALGUNA VEZ fue publicada (publishedOnce)
      else if (willBeInactivated) {
        if (publishedOnce || current.publishedOnce) {
          await webhookInactivateWcMl(id, current, linkWoo, linkML);
        }
      }
      // 3) Actualizar (si ya estaba publicada y cambió algo relevante)
      else if (wasPublished && textoClaveCambio) {
        await webhookUpdateWcMl(
          id,
          {
            ...current,
            valorRebajado: valorRebajadoForWebhook,
            remove_etiqueta: !!etiquetaQuitada,
          },
          linkWoo,
          linkML
        );
      }

      // Si el admin usó el reset, lo volvemos a poner en false en el form local
      setMoto(current);
      setForm((v) => ({ ...v, _resetPublishedOnce: false }));
      alert("Cambios guardados.");
    } catch (e) {
      console.error(e);
      alert(e.message || "Error al guardar.");
    } finally {
      setSaving(false);
    }
  }, [moto, form, id, hasAllMedia, setMoto, isInactive, isAdmin, publishedOnce, mapaSucursales]);

  if (loading || !moto) return <div className="p-6 text-gray-500">Cargando…</div>;

  const linkStates = {
    wc: !!(moto.link_wooCommerce || form.link_wooCommerce),
    ig: !!(moto.link_instagram || form.link_instagram),
    fb: !!(moto.link_facebookPage || form.link_facebookPage),
    yt: !!(moto.link_youtube || form.link_youtube),
    ml: !!(moto.link_mercadoLibre || form.link_mercadoLibre),
  };

  const disableInputs = lockUI; // bloquear edición a no-admin cuando INACTIVA

  return (
    <div className="min-h-screen bg-gray-100 text-gray-900">
      {/* Topbar */}
      <div className="px-6 py-4 border-b border-gray-200 bg-white flex justify-between items-center">
        <button
          onClick={() => nav("/dashboard")}
          className="px-3 py-2 rounded bg-white border border-gray-300 text-gray-800 hover:bg-gray-100"
        >
          ← Volver
        </button>
        <h1 className="font-semibold truncate">
          {form.nombre || moto.nombre}
        </h1>
        <div />
      </div>

      <div className="p-6 grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Galería */}
        <div>
          {main ? (
            <img
              src={main}
              alt="principal"
              className="w-full h-96 object-cover rounded border border-gray-200 bg-white"
            />
          ) : (
            <div className="w-full h-96 bg-gray-200 rounded" />
          )}

          {/* Slots 1..7 */}
          <div className="grid grid-cols-3 sm:grid-cols-4 gap-3 mt-3">
            {Array.from({ length: 7 }).map((_, i) => {
              const index = i + 1;
              const realUrl = moto?.[`foto${index}`] || null;
              const showUrl = fotos[i];

              return (
                <div key={index} className="relative group">
                  <img
                    src={showUrl}
                    alt={`foto-${index}`}
                    className={`w-full aspect-square object-cover rounded border ${
                      main === (realUrl || showUrl)
                        ? "border-gray-900"
                        : "border-gray-200"
                    }`}
                    onClick={() =>
                      realUrl
                        ? setMain(realUrl)
                        : !disableInputs &&
                          fotoInputsRef.current[i]?.click()
                    }
                    loading="lazy"
                    style={{ cursor: disableInputs ? "not-allowed" : "pointer" }}
                  />
                  <div className="absolute inset-0 hidden group-hover:flex items-center justify-center gap-2 bg-black/30 rounded">
                    <button
                      className="px-2 py-1 text-xs rounded bg-white border border-gray-300 text-red-600 hover:bg-gray-100 disabled:opacity-40"
                      disabled={!realUrl || disableInputs}
                      onClick={() => handleRemoveFoto(index)}
                    >
                      Quitar
                    </button>
                    <button
                      className="px-2 py-1 text-xs rounded bg-white border border-gray-300 hover:bg-gray-100 disabled:opacity-40"
                      disabled={disableInputs}
                      onClick={() => fotoInputsRef.current[i]?.click()}
                    >
                      Subir
                    </button>
                  </div>
                  <input
                    type="file"
                    accept="image/*"
                    className="hidden"
                    ref={(el) => (fotoInputsRef.current[i] = el)}
                    onChange={async (e) => {
                      const file = e.target.files?.[0];
                      if (file) await handleUploadFoto(index, file);
                    }}
                    disabled={disableInputs}
                  />
                </div>
              );
            })}
          </div>

          {/* Video */}
          <div className="mt-6">
            <div className="flex items-center justify-between mb-2">
              <h3 className="font-semibold">Video</h3>
              <div className="flex gap-2">
                <button
                  className="px-3 py-1 text-sm rounded bg-white border border-gray-300 hover:bg-gray-100 disabled:opacity-40"
                  onClick={() => !disableInputs && videoInputRef.current?.click()}
                  disabled={disableInputs}
                >
                  {moto?.video ? "Reemplazar video" : "Subir video"}
                </button>
                <button
                  className="px-3 py-1 text-sm rounded bg-white border border-gray-300 text-red-600 hover:bg-gray-100 disabled:opacity-40"
                  disabled={!moto?.video || disableInputs}
                  onClick={handleRemoveVideo}
                >
                  Quitar
                </button>
              </div>
            </div>

            <div className="relative">
              {moto?.video ? (
                <video
                  src={moto.video}
                  className="w-full h-52 rounded border border-gray-200 bg-gray-100"
                  controls
                />
              ) : (
                <img
                  src={phVideo}
                  alt="video-ph"
                  className="w-full h-52 object-cover rounded border border-gray-200 bg-gray-100 cursor-pointer"
                  onClick={() => !disableInputs && videoInputRef.current?.click()}
                  style={{ cursor: disableInputs ? "not-allowed" : "pointer" }}
                />
              )}
              <input
                type="file"
                accept="video/*"
                className="hidden"
                ref={videoInputRef}
                onChange={async (e) => {
                  const file = e.target.files?.[0];
                  if (file) await handleUploadVideo(file);
                }}
                disabled={disableInputs}
              />
            </div>
          </div>
        </div>

        {/* Formulario / Acciones */}
        <div className="space-y-4 bg-white p-4 rounded border border-gray-200 shadow-sm">
          {/* Admin panel rápido */}
          {isAdmin && (
            <div className="p-3 border border-gray-200 rounded bg-gray-50">
              <div className="text-sm font-semibold mb-2">Controles de admin</div>
              <div className="flex items-center gap-3">
                <label className="inline-flex items-center gap-2">
                  <input
                    type="checkbox"
                    name="_resetPublishedOnce"
                    checked={form._resetPublishedOnce}
                    onChange={onChange}
                  />
                  <span>Permitir republicación (reset publishedOnce)</span>
                </label>
                <span className="text-xs text-gray-600">
                  Estado actual: {publishedOnce ? "Ya publicada en algún canal" : "Nunca publicada"}
                </span>
              </div>
            </div>
          )}

          {/* Campos */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <div>
              <label className="text-sm text-gray-600">Nombre</label>
              <input
                name="nombre"
                value={form.nombre}
                onChange={onChange}
                disabled={disableInputs}
                className="mt-1 w-full px-3 py-2 border border-gray-300 rounded bg-gray-50 disabled:opacity-50"
              />
            </div>

            <div>
              <label className="text-sm text-gray-600">Código (no editable)</label>
              <input
                name="codigoMoto"
                value={form.codigoMoto}
                disabled
                className="mt-1 w-full px-3 py-2 border border-gray-300 rounded bg-gray-100 text-gray-600"
              />
            </div>

            <div>
              <label className="text-sm text-gray-600">Marca</label>
              <input
                name="marca"
                value={form.marca}
                onChange={onChange}
                disabled={disableInputs}
                className="mt-1 w-full px-3 py-2 border border-gray-300 rounded bg-gray-50 disabled:opacity-50"
              />
            </div>

            <div>
              <label className="text-sm text-gray-600">Modelo</label>
              <input
                name="modelo"
                value={form.modelo}
                onChange={onChange}
                disabled={disableInputs}
                className="mt-1 w-full px-3 py-2 border border-gray-300 rounded bg-gray-50 disabled:opacity-50"
              />
            </div>

            <div>
              <label className="text-sm text-gray-600">Año</label>
              <input
                name="ano"
                type="number"
                value={form.ano}
                onChange={onChange}
                disabled={disableInputs}
                className="mt-1 w-full px-3 py-2 border border-gray-300 rounded bg-gray-50 disabled:opacity-50"
              />
            </div>

            <div>
              <label className="text-sm text-gray-600">Color</label>
              <input
                name="color"
                value={form.color}
                onChange={onChange}
                disabled={disableInputs}
                className="mt-1 w-full px-3 py-2 border border-gray-300 rounded bg-gray-50 disabled:opacity-50"
              />
            </div>

            <div>
              <label className="text-sm text-gray-600">Kilómetros</label>
              <input
                name="kilometros"
                type="number"
                value={form.kilometros}
                onChange={onChange}
                disabled={disableInputs}
                className="mt-1 w-full px-3 py-2 border border-gray-300 rounded bg-gray-50 disabled:opacity-50"
              />
            </div>

            <div>
              <label className="text-sm text-gray-600">Cilindrada (cc)</label>
              <input
                name="cilindrada"
                type="number"
                value={form.cilindrada}
                onChange={onChange}
                disabled={disableInputs}
                className="mt-1 w-full px-3 py-2 border border-gray-300 rounded bg-gray-50 disabled:opacity-50"
              />
            </div>

            <div>
              <label className="text-sm text-gray-600">Precio (MXN)</label>
              <input
                name="valor"
                type="number"
                value={form.valor}
                onChange={onChange}
                placeholder="Ej. 125000"
                disabled={disableInputs}
                className="mt-1 w-full px-3 py-2 border border-gray-300 rounded bg-gray-50 disabled:opacity-50"
              />
            </div>

            <div>
              <label className="text-sm text-gray-600">Precio Rebajado (MXN)</label>
              <input
                name="valorRebajado"
                type="number"
                value={form.valorRebajado}
                onChange={onChange}
                placeholder="0"
                disabled={disableInputs}
                className="mt-1 w-full px-3 py-2 border border-gray-300 rounded bg-gray-50 disabled:opacity-50"
              />
            </div>

            <div>
              <label className="text-sm text-gray-600">Financiamiento</label>
              <select
                name="financiamiento"
                value={form.financiamiento}
                onChange={onChange}
                disabled={disableInputs}
                className="mt-1 w-full px-3 py-2 border border-gray-300 rounded bg-gray-50 disabled:opacity-50"
              >
                <option value="Sí">Sí</option>
                <option value="No">No</option>
              </select>
            </div>

            <div>
              <label className="text-sm text-gray-600">Origen</label>
              <select
                name="origen"
                value={form.origen}
                onChange={onChange}
                disabled={disableInputs}
                className="mt-1 w-full px-3 py-2 border border-gray-300 rounded bg-gray-50 disabled:opacity-50"
              >
                <option value="Nacional">Nacional</option>
                <option value="Importada">Importada</option>
              </select>
            </div>

            <div>
              <label className="text-sm text-gray-600">Tipo de moto</label>
              <input
                name="tipoMoto"
                value={form.tipoMoto}
                onChange={onChange}
                disabled={disableInputs}
                className="mt-1 w-full px-3 py-2 border border-gray-300 rounded bg-gray-50 disabled:opacity-50"
              />
            </div>

            <div>
              <label className="text-sm text-gray-600">Categoría</label>
              <select
                name="categoria"
                value={form.categoria}
                onChange={onChange}
                disabled={disableInputs}
                className="mt-1 w-full px-3 py-2 border border-gray-300 rounded bg-gray-50 disabled:opacity-50"
              >
                <option value="Seminueva">Seminueva</option>
                <option value="Nueva">Nueva</option>
              </select>
            </div>

            <div>
              <label className="text-sm text-gray-600">Sucursal</label>
              <select
                name="sucursalId"
                value={form.sucursalId}
                onChange={(e) => {
                  const sid = e.target.value;
                  const name = mapaSucursales[sid] || sid;
                  setForm((v) => ({ ...v, sucursalId: sid, sucursalNombre: name }));
                }}
                disabled={disableInputs}
                className="mt-1 w-full px-3 py-2 border border-gray-300 rounded bg-gray-50 disabled:opacity-50"
              >
                <option value="">—</option>
                {sucList.map((s) => (
                  <option key={s.id} value={s.id}>
                    {s.nombre}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="text-sm text-gray-600">Fuente (no editable)</label>
              <input
                name="fuente"
                value={form.fuente}
                disabled
                className="mt-1 w-full px-3 py-2 border border-gray-300 rounded bg-gray-100 text-gray-600"
              />
            </div>
          </div>

          {/* Descripción */}
          <div>
            <label className="text-sm text-gray-600">
              Descripción (*** una línea, sin saltos ni emojis ***)
            </label>
            <textarea
              name="descripcion"
              value={form.descripcion}
              onChange={onChange}
              disabled={disableInputs}
              className="mt-1 w-full h-28 px-3 py-2 border border-gray-300 rounded bg-gray-50 disabled:opacity-50"
            />
          </div>

          {/* Estatus + Etiqueta */}
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="text-sm text-gray-600">Estatus</label>
              <select
                name="estatus"
                value={form.estatus}
                onChange={(e) => {
                  const to = e.target.value;
                  if (to === ESTATUS.PUBLICADA && !hasAllMedia) {
                    alert("No puedes publicar sin 7 fotos y 1 video.");
                    return;
                  }
                  if (!isAdmin && publishedOnce && to === ESTATUS.PUBLICADA) {
                    alert("Ya fue publicada antes. Solo Admin puede permitir republicación.");
                    return;
                  }
                  if (!isAdmin && isInactive && to !== ESTATUS.INACTIVA) {
                    alert("La moto está inactiva. Solo Admin puede reactivarla.");
                    return;
                  }
                  onChange(e);
                }}
                disabled={disableInputs}
                className="mt-1 w-full px-3 py-2 border border-gray-300 rounded bg-gray-50 disabled:opacity-50"
              >
                <option value={ESTATUS.PENDING}>Por publicar</option>
                <option value={ESTATUS.PUBLICADA} disabled={!hasAllMedia}>
                  Publicada {hasAllMedia ? "" : " (requiere 7 fotos y 1 video)"}
                </option>
                <option value={ESTATUS.INACTIVA}>Inactiva</option>
              </select>
            </div>
            <div>
              <label className="text-sm text-gray-600">Etiqueta</label>
              <select
                name="etiqueta"
                value={form.etiqueta}
                onChange={onChange}
                disabled={disableInputs}
                className="mt-1 w-full px-3 py-2 border border-gray-300 rounded bg-gray-50 disabled:opacity-50"
              >
                <option value="">—</option>
                <option value="Promoción">Promoción</option>
                <option value="Apartada">Apartada</option>
                <option value="Vendida">Vendida</option>
                <option value="Nuevo Ingreso">Nuevo Ingreso</option>
              </select>
            </div>
          </div>

          {/* Guardar */}
          <div className="flex flex-wrap gap-3">
            <button
              onClick={guardar}
              disabled={saving}
              className="px-4 py-2 rounded bg-gray-900 text-white hover:bg-gray-800 disabled:opacity-50"
            >
              {saving ? "Guardando…" : "Guardar"}
            </button>
          </div>

          {/* Publicación: links */}
          <div className="mt-4 border border-gray-200 rounded p-3 bg-gray-50">
            <h4 className="font-semibold mb-2">Publicación</h4>
            <div className="flex items-center gap-5">
              <a
                href={moto.link_wooCommerce || form.link_wooCommerce || "#"}
                target="_blank"
                rel="noreferrer"
                className={`flex items-center gap-2 ${linkStates.wc ? "" : "grayscale pointer-events-none"}`}
                title={
                  linkStates.wc
                    ? moto.link_wooCommerce || form.link_wooCommerce
                    : "Sin link"
                }
              >
                <SiWoocommerce className="text-2xl" />
                <span className="text-sm break-all">
                  {moto.link_wooCommerce || form.link_wooCommerce || "WooCommerce"}
                </span>
              </a>

              <a
                href={moto.link_instagram || form.link_instagram || "#"}
                target="_blank"
                rel="noreferrer"
                className={`flex items-center gap-2 ${linkStates.ig ? "" : "grayscale pointer-events-none"}`}
                title={
                  linkStates.ig
                    ? moto.link_instagram || form.link_instagram
                    : "Sin link"
                }
              >
                <FaInstagram className="text-2xl" />
                <span className="text-sm break-all">
                  {moto.link_instagram || form.link_instagram || "Instagram"}
                </span>
              </a>

              <a
                href={moto.link_facebookPage || form.link_facebookPage || "#"}
                target="_blank"
                rel="noreferrer"
                className={`flex items-center gap-2 ${linkStates.fb ? "" : "grayscale pointer-events-none"}`}
                title={
                  linkStates.fb
                    ? moto.link_facebookPage || form.link_facebookPage
                    : "Sin link"
                }
              >
                <FaFacebook className="text-2xl" />
                <span className="text-sm break-all">
                  {moto.link_facebookPage || form.link_facebookPage || "Facebook Page"}
                </span>
              </a>

              <a
                href={moto.link_youtube || form.link_youtube || "#"}
                target="_blank"
                rel="noreferrer"
                className={`flex items-center gap-2 ${linkStates.yt ? "" : "grayscale pointer-events-none"}`}
                title={
                  linkStates.yt ? moto.link_youtube || form.link_youtube : "Sin link"
                }
              >
                <FaYoutube className="text-2xl" />
                <span className="text-sm break-all">
                  {moto.link_youtube || form.link_youtube || "YouTube"}
                </span>
              </a>

              <a
                href={moto.link_mercadoLibre || form.link_mercadoLibre || "#"}
                target="_blank"
                rel="noreferrer"
                className={`flex items-center gap-2 ${linkStates.ml ? "" : "grayscale pointer-events-none"}`}
                title={
                  linkStates.ml
                    ? moto.link_mercadoLibre || form.link_mercadoLibre
                    : "Sin link"
                }
              >
                <img src={mercadolibreIco} alt="MercadoLibre" width={24} height={24} />
                <span className="text-sm break-all">
                  {moto.link_mercadoLibre || form.link_mercadoLibre || "MercadoLibre"}
                </span>
              </a>
            </div>
          </div>

          {/* Timestamps */}
          <div className="text-sm text-gray-500 space-y-1">
            {moto.publishedAt_wc && (
              <div>WooCommerce: {new Date(moto.publishedAt_wc).toLocaleString()}</div>
            )}
            {moto.publishedAt_ml && (
              <div>MercadoLibre: {new Date(moto.publishedAt_ml).toLocaleString()}</div>
            )}
            {(moto.sucursalNombre || moto.sucursalId || moto.sucursal) && (
              <div>
                Sucursal: {moto.sucursalNombre || mapaSucursales[moto.sucursalId] || moto.sucursal || moto.sucursalId}
              </div>
            )}
          </div>

          {/* Debug */}
          <details className="mt-4 text-gray-700">
            <summary className="cursor-pointer text-gray-500">Ver todos los campos</summary>
            <pre className="mt-2 text-xs text-gray-700 bg-gray-100 p-3 rounded border border-gray-200 overflow-auto">
{JSON.stringify(moto, null, 2)}
            </pre>
          </details>
        </div>
      </div>
    </div>
  );
}